'use client';

import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';

import { useIsCheckoutRoute } from './Base/useIsCheckoutRoute';
import { AccountSlot } from './IndividualSlots/AccountSlot';
import { BasketSlot } from './IndividualSlots/BasketSlot';
import { SearchSlot } from './IndividualSlots/SearchSlot';
import { WishlistSlot } from './IndividualSlots/WishlistSlot';
import { ServiceSlot } from './IndividualSlots/ServiceSlot';
import { LocaleSwitchSlot } from './IndividualSlots/LocaleSwitchSlot';
import { PaybackSlot } from './IndividualSlots/PaybackSlot';
import { JoeSlot } from './IndividualSlots/JoeSlot';
import { SlotsContainer } from './Base/SlotsContainer';
import type { SlotPriority } from './Base/types';

export const SlotsDefault = () => {
  const {
    headerSlots: { payback, localeSwitcher, joe, serviceApi },
  } = useConfig();
  const isCheckoutRoute = useIsCheckoutRoute();

  // NOTE distribute priorities to all visible slots, starting from 1, to make sure the priorities are monotonously increasing from 1 to N, even if some slots are missing, and that the priorities are assigned to the correct slots in the right order
  // NOTE The booleans in the array have to match the rendering conditionals in the TSX, to skip the correct slots when distributing priorities
  let lowestAvailablePriority = 1;
  const priorityOrder: SlotPriority[] = [
    !isCheckoutRoute, // search field
    true, // account slot
    true, // wishlist slot
    true, // basket slot
    localeSwitcher, // locale switcher
    joe || payback, // joe/payback slot
    // eslint-disable-next-line no-plusplus
  ].map((exists) => (exists ? (lowestAvailablePriority++ as SlotPriority) : 999));

  return (
    <SlotsContainer>
      {localeSwitcher && (
        // workaround: legacy fragment-header used a confusing mess of nth selectors and overrides
        // proper solution needs UI layout redesign
        <LocaleSwitchSlot priority={priorityOrder[4]} />
      )}
      {payback && <PaybackSlot priority={priorityOrder[5]} />}
      {joe && <JoeSlot priority={priorityOrder[5]} />}
      {/* always hidden on mobile, hence no priority needed */}
      {serviceApi && <ServiceSlot priority={0} />}
      {/* workaround: legacy fragment-header used (max-width: 374px) with inverted logic */}
      {/* proper solution needs UI layout redesign */}
      <AccountSlot priority={priorityOrder[1]} />
      {!isCheckoutRoute && <SearchSlot priority={priorityOrder[0]} />}
      <WishlistSlot priority={priorityOrder[3]} />
      {!isCheckoutRoute && <BasketSlot priority={priorityOrder[2]} />}
    </SlotsContainer>
  );
};
